import { AccessStatus } from '@/app.manager/types';
import { init } from '@/shared/providers';
import { localeService, ManifestService } from '@/shared/services';
import { AllowedLocales } from '@/shared/services/locale/localeService';
import { i18n } from '@/i18n';

export const hasKey = function hasOwnKey(item: Object, key: string) {
  return Object.prototype.hasOwnProperty.call(item, key);
};

export function updateAppStatus(payload: any, status: AccessStatus) {
  return {
    ...payload,
    appStatus: status,
    status,
  };
}

export function adjustDisplayPages(workflow: any, payload: any, status: AccessStatus) {
  const isResultsApp = payload.appConfig === 'resultsConfig';

  const pagesOnCompleted = workflow?.pagesOnCompleted?.pages || workflow?.pagesOnCompleted;
  const pagesOnCompletedKeys = pagesOnCompleted?.map((x: { key: string }) => x.key);

  if (!isResultsApp && status === AccessStatus.COMPLETED) {
    workflow.pages = workflow.pages
      .filter((page: { key:string }) => pagesOnCompleted.some((x: any) => x.key === page.key))
      .sort((a: any, b: any) => pagesOnCompletedKeys.indexOf(a.key) - pagesOnCompletedKeys.indexOf(b.key));
  }
}

export async function updateLocal(manifest:any, userLang:AllowedLocales, baseUrl?:string, manifestLocaleData?: any) {
  const manifestService = new ManifestService(manifest, userLang, baseUrl);

  if (manifestService.globalStoredInUIAssets) {
    await localeService.getGlobalTranslations(userLang);
  }

  const manifestLocale = manifestLocaleData || await manifestService.getRrpByLocale(userLang);

  const validationMessagesOverrides = manifestLocale?.validationMessagesOverrides;

  localeService.addTranslation(userLang, manifestLocale);

  // initialize validation translations
  await init(userLang, localeService.getValidationTranslations(userLang), validationMessagesOverrides);
}

export function getLanguages(organizationConfig: any, manifest: any) {
  const organizationLanguages = organizationConfig?.languagesCodes;
  const rrpLanguages = Object.keys(manifest?.rrpConfig?.translations || {});

  return organizationLanguages.filter((lang: string) => rrpLanguages.includes(lang));
}

export const transformInputLabelToRequired = (inputLabel: string, validatorRules: Record<string, string|boolean> = {}) => (
  validatorRules?.required ? `${i18n.global.t(inputLabel)} *` : i18n.global.t(inputLabel)
);

export const isDevMode = () => import.meta.env.MODE === 'development';
